import React from "react";
import { useLocation, Link } from "react-router-dom";
import { connect } from 'react-redux';
import MUIDataTable from "mui-datatables";
import Chip from '@material-ui/core/Chip';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import moment from 'moment'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress'
import Make from 'components/Self/Make.js';
import { Helmet } from "react-helmet";
// import EditIcon from '@material-ui/icons/Edit';
import axios from 'axios';
// reactstrap components
import { Button, Container, Row, Col,FormGroup, Modal } from "reactstrap";
import { Avatar } from "@material-ui/core";
// import classes from "*.module.css";


const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MUIDataTable: {
                root: {
                    backgroundColor: '#000',
                },
                paper: {
                    backgroundColor: '#000',
                    borderRadius: '10px',
                },
            },
            MuiToolbar: {
                root: {
                    color: "f4f5f7"
                },
            },
            MuiTableCell: {
                head: {
                    backgroundColor: 'purple',
                },
                root: {
                    borderBottom: 'none',
                }
            },
            MuiSvgIcon: {
                root: {
                    backgroundColor: '',
                    color: 'white !important',
                    '&:hover': {
                        color: "#a5a7bc"
                    }
                }
            },
            MuiInputBase: {
                input: {
                    borderBottom: '1px solid white',
                    '&:hover': {
                        // borderBottom: '1px solid #ff0000 !important',
                        outline: '0 !important',
                    }
                }
            },
            MuiInput: {
                formControl: {
                    color: 'white',
                    borderBottom: '1px solid white',
                    '&:hover': {
                        borderBottom: '1px solid #fff !important',
                        outline: '0 !important',
                    }
                }
            },
            MUIDataTableFilter: {
                root: {
                    backgroundColor: '#000',
                    color: 'white'
                },
                title: {
                    color: 'white'
                },
            },
            MUIDataTableToolbarSelect: {
                root: {
                    backgroundColor: '#000',
                    color: 'white'
                },
                title: {
                    color: 'white'
                },
            },
            MuiTypography: {
                root: {
                    color: 'white !important'
                },
            },
            MUIDataTableViewCol: {
                root: {
                    backgroundColor: '#000'
                },
                title: {
                    color: 'white'
                },
                label: {
                    color: 'white'
                }
            },
            MuiTablePagination: {
                selectIcon: {
                    color: 'white',
                }
            },
            MuiIconButton: {
                root: {
                    backgroundColor: '',
                    color: 'yellow',
                    '&:hover': {
                        color: "#a5a7bc"
                    }
                },
                label: {
                    backgroundColor: '',
                }
            },
            MUIDataTableBodyRow: {
                root: {
                    backgroundColor: 'transparent',
                }
            },
            MuiTableRow: {
                root:
                {
                    '&$hover:hover':
                        { backgroundColor: '#1e1e1e' }
                }
            },
            MUIDataTableBodyCell: {
                root: {
                    color: "#f4f5f7"
                }
            },
            MUIDataTableHeadRow: {
                root: {
                    backgroundColor: "transparent",
                    height: '5px',
                    borderBottom: '1px solid #243d66',
                },
            },
            MUIDataTableHeadCell: {
                data: {
                    color: "white",
                },
                fixedHeader: {
                    backgroundColor: "transparent",
                    color: "white"
                },
                sortActive: {
                    backgroundColor: '',
                    color: '#c5c7dc'
                }
            },
            MuiHeader: {
                backgroundColor: "green"
            },
            MuiTableFooter: {
                root: {
                    '& .MuiToolbar-root': {
                        color: '#f4f5f7',
                    },
                },
            },
            MUIDataTableToolbar: {
                root: {
                    backgroundColor: '',
                    color: "#f4f5f7",
                },
                icon: {
                    color: "#f4f5f7",
                    '&:hover': {
                        color: "#a5a7bc"
                    }
                },
            },
            MUIDataTableSelectCell: {
                headerCell: {
                    backgroundColor: 'transparent',
                },
            },
        },
    });


const getMuiTheme2 = () =>
    createMuiTheme({
        overrides: {
            MUIDataTableToolbar: {
                root: {
                    backgroundColor: '',
                    color: "#32325d",
                },
                icon: {
                    color: "#32325d",
                    '&:hover': {
                        color: "#32325d"
                    }
                },
            },
            MuiSvgIcon: {
                color: "#32325d !important",
            }
        },
    });
const colors = [ "AliceBlue", "AntiqueWhite", "Aqua", "Aquamarine", "Azure", "Beige", "Bisque", "Black", "BlanchedAlmond", "Blue", "BlueViolet", "Brown", "BurlyWood", "CadetBlue", "Chartreuse", "Chocolate", "Coral", "CornflowerBlue", "Cornsilk", "Crimson", "Cyan", "DarkBlue", "DarkCyan", "DarkGoldenRod", "DarkGray", "DarkGrey", "DarkGreen", "DarkKhaki", "DarkMagenta", "DarkOliveGreen", "DarkOrange", "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen", "DarkSlateBlue", "DarkSlateGray", "DarkSlateGrey", "DarkTurquoise", "DarkViolet", "DeepPink", "DeepSkyBlue", "DimGray", "DimGrey", "DodgerBlue", "FireBrick", "FloralWhite", "ForestGreen", "Fuchsia", "Gainsboro", "Gold", "GoldenRod", "Gray", "Grey", "Green", "GreenYellow", "HoneyDew", "HotPink", "IndianRed", "Indigo", "Ivory", "Khaki", "Lavender", "LavenderBlush", "LawnGreen", "LemonChiffon", "LightBlue", "LightCoral", "LightCyan", "LightGoldenRodYellow", "LightGreen", "LightPink", "LightSalmon", "LightSeaGreen", "LightSkyBlue", "LightSlateGray", "LightSlateGrey", "LightSteelBlue", "LightYellow", "Lime", "LimeGreen", "Linen", "Magenta", "Maroon", "MediumAquaMarine", "MediumBlue", "MediumOrchid", "MediumPurple", "MediumSeaGreen", "MediumSlateBlue", "MediumSpringGreen", "MediumTurquoise", "MediumVioletRed", "MidnightBlue", "MintCream", "MistyRose", "Moccasin", "NavajoWhite", "Navy", "OldLace", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid", "PaleGoldenRod", "PaleGreen", "PaleTurquoise", "PaleVioletRed", "PapayaWhip", "PeachPuff", "Peru", "Pink", "Plum", "PowderBlue", "Purple", "RebeccaPurple", "Red", "RosyBrown", "RoyalBlue", "SaddleBrown", "Salmon", "SandyBrown", "SeaGreen", "SeaShell", "Sienna", "Silver", "SkyBlue", "SlateBlue", "SlateGray", "SlateGrey", "Snow", "SpringGreen", "SteelBlue", "Tan", "Teal", "Thistle", "Tomato", "Turquoise", "Violet", "Wheat", "WhiteSmoke", "Yellow", "YellowGreen",
];

const useStyles = makeStyles((theme: Theme) =>
    
    createStyles({
        avatar2: {
            height: '27px',
            width: '27px',
            // backgroundColor: colors[Math.floor(Math.random() * colors.length)]
        },
    }),
);

const Negotiations = (props) => {
    const location = useLocation();
    // const history = useHistory();
    const classes = useStyles();
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    // const [open2, setOpen2] = React.useState(false);
    // const [active, setActive] = React.useState(true);
    // const [snackm, setSnackm] = React.useState('');
    const [deleteloading, setdeleteloading] = React.useState('Delete');
    const [deletedisabling, setdeletedisabling] = React.useState(false);
    const [loading, setloading] = React.useState(true);
    const [tablename, settablename] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [filterset, setfilterset] = React.useState(false);
    const [del, setdel] = React.useState([]);
    const [filtered, setfiltered] = React.useState([]);
    var delx
    if (location) {
        // console.log('yes location')
        // console.log(location);
        // console.log(location.state);
        if (location.state != null) {
            if (location.state.token) {
                if (location.state.token === 1) {
                    // console.log(location.state.message);
                    setSendingdata(location.state.message)
                    settt(location.state.type)
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }

    }
    else {
        // console.log('nope')
    }
    // const userd = props.username;
    const [responseData2, setResponseData2] = React.useState([])
    const fetchData = React.useCallback(() => {
        axios.get(process.env.REACT_APP_DOMAIN+"/allaccounts", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setResponseData2(response.data)
                // console.log(response.data)
                settablename('No Accounts Found ')
                setloading(false)
            })
            .catch((error) => {
                console.log(error)
                setloading(false)
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
                settablename('Something went Wrong')
            })
        // axios.get("http://www.omdbapi.com/?t=Game%20of%20Thrones&Season=1&Episode=1&apikey=3c4f2af2")
        //     .then((response) => {
        //         console.log(response.data)
        //         // setResponseData2(response.data)
        //         // // console.log(response.data)
        //         // settablename('No Accounts Found ')
        //         // setloading(false)
        //     })
        //     .catch((error) => {
        //         console.log(error)
        //         setloading(false)
        //         setSendingdata('Something went wrong')
        //         settt('error')
        //         setOpen(true)
        //         settablename('Something went Wrong')
        //     })
    }, [props.token])
    React.useEffect(() => {
        fetchData()
        document.title = "Accounts - Depact"
    }, [fetchData])

    const data2 = []
    if(responseData2){
        responseData2.map(function (responseData, index) {
                var make
                var typei
                var uu
                var action
                // console.log(responseData.email2)
                if(responseData.type === 'Student'){
                    make = 'admin'
                    uu = false
                }
                else if (responseData.type === 'Faculty') {
                    make = 'super'
                    action='Admin'
                    typei = 'info'
                    uu = true
                }
                else {
                    make = 'admin'
                    action='Faculty'
                    typei='danger'
                    uu = true
                }
                if(typei){
                    // console.log('')
                }
                data2.push({
                    TID: responseData.id, Type: responseData.type, Action: {make: make, user: responseData.id,uu: uu,type: typei,action: action},
                    User: [responseData.username, responseData.id, process.env.REACT_APP_DOMAIN+'' + responseData.photo,colors[Math.floor(Math.random() * colors.length)]],FullName: responseData.first_name+' '+responseData.last_name,
                    Email: responseData.email,
                    Joined: responseData.date_joined,
                    LastLogin: responseData.last_login,
                })
                return (<div></div>)

        })
    }


    const columnsx = [{ name: "TID", label: 'ID', options: { filter: true, filterType: 'textField', sort: true, } },
    { name: "Type", label: "Type", options: { filter: true, sort: true, customBodyRender: (value) => (<Chip label={value} />) } },
    { name: "User", label: "User", options: { filter: true, filterType: 'textField', sort: true, customBodyRender: (value) => (<Link to={'/main/profile/'+value[0]}><div style={{display: 'flex',minWidth: '100px'}} className="mt-v">
    <Avatar style={{backgroundColor: value[3]}} className={classes.avatar2} aria-label="recipe" src={value[2]} >{value[0].substring(0, 1)}</Avatar>
    <p style={{flex:1}} className={"point underline-hover ml-1 texts-" + props.theme}> {value[0]} </p></div></Link>) } },
    { name: "FullName", label: "Full Name", options: { filter: true, filterType: 'textField', sort: true, } },
    { name: "Email", label: "Email", options: { filter: true, filterType: 'textField', sort: true, customBodyRender: (value) => (<a target="_blank" rel="noreferrer" className={"point underline-hover ml-1 texts-" + props.theme} href={"https://mail.google.com/mail/?view=cm&fs=1&to="+value}>{value}</a>)  } },
    { name: "Action", label: "Action", options: { filter: false, sort: false, download: false, customBodyRender: (value) => ((value.uu ? <Make label={value} fetch={props.fetch} fetching={fetchData} />: null)) } },
    { name: "LastLogin", label: "Last Login", options: { filter: false, sort: true, customBodyRender: (value) => (<div>{moment(value).fromNow()}</div>) } },
    { name: "Joined", label: "Joined", options: { filter: true, filterType: 'textField', sort: true, customBodyRender: (value) => (<div>{moment(value).format('Do MMM YY')}</div>) } },
        // { name: "Last", label: "Last Edited", options: { filter: false, sort: true, } },

    ]
    
    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const handleClose2 = (event, reason) => {
        setOpen2(false);
    };

    const handleDelete = () => {
        // console.log(del)
        // console.log(del.length)
        setdeleteloading(<CircularProgress size="20px" style={{ color: '#172b4d' }} />)
        setdeletedisabling(true)
        if ((del.length < 1) || (del === undefined)) {
            setSendingdata('Something went wrong')
            settt('error')
            setOpen(true);
            setdeleteloading('Delete')
            setdeletedisabling(false)
            return 0;
        }
        // console.log(del)
        axios.post(process.env.REACT_APP_DOMAIN+'/deleteaccounts', { data: del }, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setOpen(true)
                setSendingdata(response.data.message)
                settt(response.data.type)
                setOpen2(false)
                setdeleteloading('Delete')
                setdeletedisabling(false)
                fetchData();
            })
            .catch((error) => {
                console.log(error)
                setOpen(true)
                setSendingdata('Something went wrong')
                settt('error')
                setOpen2(false)
                setdeleteloading('Delete')
                setdeletedisabling(false)
                fetchData();
            })
    };

    const optionsx = {
        filterType: 'checkbox',
        responsive: 'standard',
        textLabels: {
            body: {
                noMatch: loading ? <CircularProgress className={"mt-2 bg-yellowx mb-2 textb-" + props.theme} /> : tablename,
            },
        },
        onRowsDelete: (rowsDeleted) => {
            // console.log(rowsDeleted.data)
            setdel([])
            delx = []
            for (var i = 0; i < rowsDeleted.data.length; i++) {
                // console.log(data2[rowsDeleted.data[i].index]['TID'])
                delx.push(data2[rowsDeleted.data[i].index]['TID'])
            }
            setdel(delx)
            setOpen2(true)
            return false;
        },
        // onDownload: (buildHead, buildBody, columns, data) => {
        //     for (var i = 0; i < data.length; i++) {
        //         // console.log(data[i])
        //         // console.log(data[i].data[1])
        //         data[i].data[2] = data[i].data[2][0]
        //         data[i].data[1] = data[i].data[1][0]
        //     }
        //     return "\uFEFF" + buildHead(columns) + buildBody(data);
        // },
        onFilterChange: (changedColumn, filterList, type, changedColumnIndex, displayData) => {
            setfiltered(displayData)
            setfilterset(true)
        },
        onDownload: (buildHead, buildBody, columns, data) => {
            if (filterset === true) {
                var filterdata = []
                console.log(data)
                data.map(function (cur, index) {
                    filtered.map(function (cur2, index) {
                        if (cur.index === cur2.dataIndex) {
                            console.log('yes')
                            filterdata.push(cur)
                        }
                        return (null)
                    })
                    return (null)
                })
                console.log(filterdata)
                return "\uFEFF" + buildHead(columns) + buildBody(filterdata);
            }
            else {
                console.log(data)
                return "\uFEFF" + buildHead(columns) + buildBody(data);
            }

        },
        downloadOptions: {
            filename: 'accounts.csv',
            separator: ','
        },
        print: false,
        customSort: (data, colIndex, order, meta) => {
            if (colIndex === 2) {
                // console.log(colIndex)
                return data.sort((a, b) => {
                    return (a.data[colIndex][0] < b.data[colIndex][0] ? -1 : 1) * (order === 'desc' ? 1 : -1);
                });
            }
            else {
                return data.sort((a, b) => {
                    // console.log(a.data[colIndex])
                    return (a.data[colIndex] < b.data[colIndex] ? -1 : 1) * (order === 'desc' ? 1 : -1);
                });
            }
        },
        selectableRows: 'single'
    };
    // console.log()
    return (
        <>
            <div className="header bg-gradient-infoc pb-8 pt-5 pt-md-8">
                <Container fluid>
                    <div className="header-body">
                    </div>
                </Container>
            </div>
            <Container className="mt--8" fluid>
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta name="theme-color" content="#ffffff" />
                    <meta name="description" content={'Accounts Section for Super Admins'} />
                    <meta property="og:description" content={'Accounts Section for Super Admins'} />
                    <meta property="og:title" content='DepAct' />
                    <meta property="og:type" content="Accounts" />
                    <meta property="og:url" content={"https://depact-kjsieit.vercel.app/main/accounts"} />
                </Helmet>
                <div className="header-body">
                    <Row>
                        <Col lg="12" xl="12" xs="12" className="mb-4">
                            <div style={{ height: 'wrap-content', width: '100%' }}>
                                    
                                {(props.theme === 'white' ?
                                    <MuiThemeProvider theme={getMuiTheme2()}>
                                    <MUIDataTable
                                        className={"back noshad cardbg-" + props.theme}
                                        title={<div className="mt-4 mb-3" style={{ width: '100%', backgroundColor: '' }}><div className="col pl-0">
                                            <h6 className="text-uppercase ls-1 mb-1">
                                                All
                                        </h6>
                                            <h2 className="text-whiteg mb-0">Accounts</h2>
                                        </div></div>}
                                        data={data2}
                                        columns={columnsx}
                                        options={optionsx}
                                    />
                                    </MuiThemeProvider>
                                    :
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                        <MUIDataTable
                                            className={"back cardbg-" + props.theme}
                                            title={<div className="mt-4 mb-3" style={{ width: '100%', backgroundColor: '' }}><div className="col pl-0">
                                                <h6 className="text-uppercase text-light ls-1 mb-1">
                                                    All
                                        </h6>
                                                <h2 className="text-white mb-0">Accounts</h2>
                                            </div></div>}
                                            data={data2}
                                            columns={columnsx}
                                            options={optionsx}
                                        />
                                    </MuiThemeProvider>
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
            <Modal
                className="modal-dialog-centered"
                isOpen={open2}
                toggle={handleClose2}>
                <div className="modal-header">
                    <h2 className="modal-title mt-2 mb-0" id="modal-title-default">  Delete Accounts </h2>
                    <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleClose2}> <span aria-hidden={true}>×</span> </button>

                </div>
                <div className="modal-header text-muted mt-0 mb-0">
                    <small>Note : If you move forward these accounts they will be permanently deleted. This will be notified to the selected people.</small>
                </div>
                <Row className="modal-body bg-orangec">
                    <Col lg="6">
                        <FormGroup>
                            <label className="form-control-label mt-2" htmlFor="input-bags">Are you Sure ?</label>
                        </FormGroup>
                    </Col>
                </Row>
                <div className="modal-footer bg-tealx pt-0">
                    <Button color="inf" data-dismiss="modal" type="button" onClick={handleClose2}> Close </Button>
                    <Button className="ml-auto" color="danger" onClick={handleDelete} disabled={deletedisabling} outline> {deleteloading} </Button>
                </div>
            </Modal>
            <Container className="mt-3" fluid>
                <div className="header-body">
                    <Row>
                        <Col lg="8" xl="8" xs="8" className="mb-4">
                            <div style={{ height: 'wrap-content', width: '100%' }}>
                                <MuiThemeProvider theme={getMuiTheme()}>
                                </MuiThemeProvider>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
            <Container className="mt-0" fluid>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        theme: state.theme,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Negotiations);
